import el from "@cypherpotato/el";
import { throttledCall } from "../ui/throttle";
import { CodeEditor } from "./code-editor";
import { Icon } from "./icon";

export function JsonControl({ id, value, readonly = false }) {

    const errorMessage = el.state.create(null);

    var codeEditor = CodeEditor({
        value: value && JSON.stringify(value, null, 2) || "",
        language: "json",
        editorProps: {
            readonly
        },
        props: {
            onInput(event) {
                throttledCall(() => {
                    try {
                        JSON.parse(event.target.value);
                        errorMessage.value = null;
                    } catch (e) {
                        errorMessage.value = e.message;
                    }
                }, 250);
            }
        }
    });

    return el(".json-editor-wrapper",
        codeEditor,
        el.state.listening([errorMessage], () =>
            el(".json-editor-error",
                errorMessage.value && el("div",
                    Icon("error-warning-line"),
                    errorMessage.value
                ),
                {
                    classList: [errorMessage.value && "has-errors"]
                }
            )
        ),
        {
            id,
            $properties: {
                value: {
                    get() {
                        try {
                            var result = JSON.parse(codeEditor.value);
                            errorMessage.value = null;
                            return result;
                        } catch (e) {
                            errorMessage.value = e.message;
                            return null;
                        }
                    },
                    set(value) {
                        var json = JSON.stringify(value, null, 2);
                        codeEditor.value = json;
                    }
                }
            }
        }
    )
}